import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Trade } from './trade.model';

@Injectable({
  providedIn: 'root'
})
export class TradeService {
  private apiUrl = `${environment.applicationApi}/messages/trades`;

  constructor(private http: HttpClient) { }

  getTrades(): Observable<Trade[]> {
    return this.http.get<Trade[]>(this.apiUrl);
  }
}